import React from "react"
import Layout from "../components/layout"
import Image from "../components/image"
import Hero from "../components/hero"
import ReadNext from "../components/read-next"

export default function MessageFromTheMd() {
  return (
    <Layout>
      <section className="page page--margin-small page--pullBottom">
        <span className="anchor" id="message" />
        <Hero
          title="Message from the Managing&nbsp;Director"
          image="home/kristalina-office.jpg"
        />
        <div className="container container--full md:container--small text-block">
          <p>Dear Reader,</p>
          <p>
            More than a year into a crisis like no other, we have mobilized a
            response like no other.
          </p>
          <p>
            As of the end of April, the IMF had approved loans to 86 countries
            totaling more than $110 billion since the onset of the pandemic—a
            record number. The August 2021 approval of a new allocation of
            Special Drawing Rights (SDRs) is another unprecedented action. At
            $650 billion, this is the largest allocation in the IMF’s history,
            and it will substantially boost the reserves and liquidity of the
            IMF’s member countries, without adding to their debt burdens. We are
            also exploring options for those with strong financial positions to
            voluntarily channel SDRs to vulnerable countries.
          </p>
          <p>
            Together with the swift and extraordinary measures taken by
            governments and central banks, these actions helped put a floor
            under the global economy in the early stages of the crisis and
            provided the basis for the emerging recovery. But this recovery is
            on two tracks: economic fortunes across countries are diverging
            dangerously, driven by dramatic differences in access to vaccines
            and the scope to provide policy support. While advanced economies
            are bouncing back, the crisis is deepening for many emerging market
            and developing economies.
          </p>
          <p>
            The most urgent task remains to get the world vaccinated as quickly
            as possible. In May, IMF staff put forward a $50 billion plan that
            targets vaccinating at least 40 percent of the population in all
            countries by the end of 2021, and 60 percent by the first half of
            2022—an investment that would boost global economic activity by
            trillions of dollars over the next few years.
          </p>
          <p>
            Closing this gap is key to ending the pandemic and ensuring a
            sustainable long-term recovery <i>everywhere</i>.
          </p>
          <p>
            A second immediate priority is helping countries deal with growing
            public debt burdens. High levels of debt heading into the crisis
            left many low-income countries more vulnerable and continues to
            limit their ability to provide much-needed policy support. We
            expanded concessional financing for low-income countries and
            provided debt relief to 29 of our poorest members, giving them some
            breathing space. But more needs to be done, including through the
            G20 Common Framework for Debt Treatments, which the IMF is actively
            supporting.
          </p>
          <p>
            Finally, the world needs to seize the opportunity to build forward
            better. We must put in place policies that not only strengthen the
            near-term recovery, but transformative policies that provide a
            foundation for a greener, more digital and inclusive global economy
            of tomorrow. More than ever we see the profound implications climate
            change has for macroeconomic performance and financial stability,
            and we are putting these critical aspects of climate action at the
            core of our work.
          </p>
          <p>
            This <i>Annual Report</i> highlights the IMF’s work and coverage in
            these areas, through policy advice, lending, and capacity
            development. Along with the unstinting efforts of our staff, it
            emphasizes the work of the IMF’s Executive Board, whose guidance and
            oversight are central to our efforts to ensure global financial
            stability and growth.
          </p>
          <p>
            Much about this pandemic and our response has been unprecedented,
            but our founding values—centered on global cooperation and support
            for our 190 member countries—endure.
          </p>
          <div className="home__byline">
            <div className="home__byline__signature">
              <Image
                path="home/kristalina_signature.jpg"
                alt="Kristalina Georgieva's Signature"
              />
              <h3>Kristalina Georgieva</h3>
              <span>Managing Director</span>
            </div>
          </div>
        </div>
      </section>

      <ReadNext sectionID="spotlight" pageID="covid-19" />
    </Layout>
  )
}
